import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
    TextField,
    Autocomplete,
    InputAdornment,
    IconButton,
    CircularProgress
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import debounce from "lodash.debounce";

import { getActiveSearchProducts } from "../../redux/actions/productActions";


const SearchBar = ({ width = "520px" }) => {

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [searchText, setSearchText] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const {
        searchResults = [],
        loading
    } = useSelector(
        state => state.productsState
    );



    const searchProducts = useMemo(

        () => debounce((text)=>{

            if(text.trim().length >= 2){

                dispatch(
                    getActiveSearchProducts(text.trim())
                );

            }

        },500),

        [dispatch]

    );



    useEffect(()=>{

        searchProducts(searchText);


        return ()=>{
            searchProducts.cancel();
        }

    },[searchText,searchProducts]);




    const handleProductSelect=(event,product)=>{


        if(!product) return;


        setSelectedProduct(product);


        navigate(
            `/${product.category}${
                product.subCategory
                ? `/${product.subCategory}`
                :""
            }/${product.slug}`
        );


        setSearchText("");

    };



return (

<Autocomplete

    className="premium-search"

    fullWidth


    value={selectedProduct}


    inputValue={searchText}


    onInputChange={(event,value)=>{

        setSearchText(value);

    }}


    onChange={handleProductSelect}


    options={searchResults}


    loading={loading}


    filterOptions={(options)=>options}


    getOptionLabel={(option)=>
        option?.productName || ""
    }


    noOptionsText={
        searchText.length < 2
        ?
        "Type at least 2 characters"
        :
        "No products found"
    }


    sx={{

        width:{
            xs:"100%",
            sm:width,
            md:width
        },


        "& .MuiAutocomplete-popper":{

            marginTop:"8px"

        }

    }}




    renderInput={(params)=>(

    <TextField


        {...params}


        placeholder="Search products..."


        size="small"



        InputProps={{

            ...params.InputProps,


            endAdornment:(

            <InputAdornment
            position="end"
            sx={{
                display:"flex",
                alignItems:"center",
                gap:"5px"
            }}
            >

            {
            loading &&
            (
                <CircularProgress
                size={18}
                thickness={5}
                />
            )
            }


            <IconButton

            size="small"

            sx={{
                color:"#4C348C"
            }}

            >

                <SearchIcon/>

            </IconButton>


            </InputAdornment>

            )

        }}




        sx={{

        width:"100%",


        "& .MuiOutlinedInput-root":{


            minHeight:"46px",


            borderRadius:"30px",


            background:"#fff",


            paddingLeft:"18px",


            paddingRight:"12px",


            boxShadow:
            "0 4px 18px rgba(0,0,0,0.08)",


            transition:"all .25s ease",



            "& fieldset":{

                border:"1px solid #e5e5e5"

            },


            "&:hover":{

                boxShadow:
                "0 6px 22px rgba(76,52,140,.15)"

            },


            "&:hover fieldset":{

                borderColor:"#4C348C"

            },


            "&.Mui-focused":{

                boxShadow:
                "0 6px 25px rgba(76,52,140,.20)"

            },


            "&.Mui-focused fieldset":{

                borderColor:"#4C348C",

                borderWidth:"2px"

            }


        },



        "& input":{

            fontSize:"15px",

            fontWeight:400,

            color:"#222"

        },



        "& input::placeholder":{

            color:"#999",

            opacity:1

        }


        }}

    />


    )}



/>

);


};


export default SearchBar;